import { useState } from 'react';

import { useDebounce } from './use-debounce';

export function useDebouncedState<T>(value: T, delay = 500) {
  const [stateValue, setStateValue] = useState<T>(value);
  const debouncedSetDebouncedValue = useDebounce(stateValue, delay);

  return [debouncedSetDebouncedValue, setStateValue, stateValue] as const;
}

export default useDebouncedState;
